import Vue from 'vue'

Vue.filter('fecha', function (value) {
    if ((value !== '') && (value !== null)){
        // Separamos fecha y hora
        let partes = value.split(" ")

        // Formateamos fecha
        let trozos = partes[0].split("-")
        let dia = trozos[2]
        let mes = trozos[1]
        let anio = trozos[0]

        return dia + "/" + mes + "/" + anio
    } else {
        return "";
    }
});

Vue.filter('fechaHora', function (value) {

    if ((value !== '') && (value !== null)) {

        // Separamos fecha y hora
        let partes = value.split(" ")

        // Formateamos fecha
        let trozosFecha = partes[0].split("-")
        let dia = trozosFecha[2]
        let mes = trozosFecha[1]
        let anio = trozosFecha[0]

        // Formateamos hora
        let trozosHora = partes[1].split(":")
        let horas = trozosHora[0]
        let minutos = trozosHora[1]

        return dia + "/" + mes + "/" + anio + " " + horas + ":" + minutos;
    } else {
        return "";
    }
});
